import {
  EnrichedVideoEditorEditListItemDto,
  VideoEditorPublishedPlatformEntryDtoStatus,
} from '@app/modules/video-editions/types';

export type CompletedPublishedPlatformsSummary = {
  count: number;
  /** API platform keys with a completed publish (order matches list payload). */
  platformKeys: string[];
};

/**
 * Derives completed publish count and platform keys from edit list payload.
 */
export function getCompletedPublishedPlatformsSummary(
  publishedPlatforms: EnrichedVideoEditorEditListItemDto['publishedPlatforms'],
): CompletedPublishedPlatformsSummary {
  if (!publishedPlatforms?.length) {
    return { count: 0, platformKeys: [] };
  }
  const completed = publishedPlatforms.filter(
    (p) => p.status === VideoEditorPublishedPlatformEntryDtoStatus.COMPLETED,
  );
  return {
    count: completed.length,
    platformKeys: completed.map((p) => p.platform),
  };
}
